import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, computed } from 'vue';
import {
  Modal,
  ButtonPrimary,
  BaseText,
  ButtonContainer,
  SingleInput
} from '@warrenbrasil/nebraska-web';

interface Props {
  isOpenModal: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalCreateWallet',
  props: {
    isOpenModal: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {




const inputText = ref('');
const isLoading = ref(false);

const createWallet = inject('createWallet', async (name: string) => ({ name }));

const counter = computed(() => {
  return `${inputText.value.length}/30`;
});

function handleChangePortfolioName(text: string) {
  if (text.trim() === '') {
    inputText.value = text.trim();
    return;
  }
  inputText.value = text;
}

async function handleCreateWallet() {
  try {
    isLoading.value = true;
    await createWallet(inputText.value ? inputText.value : 'Nova carteira');
  } finally {
    isLoading.value = false;
  }
}

function closeModal() {
  emit('close');
  inputText.value = '';
}

return { __sfc: true,emit, inputText, isLoading, createWallet, counter, handleChangePortfolioName, handleCreateWallet, closeModal, Modal, ButtonPrimary, BaseText, ButtonContainer, SingleInput }
}

})